import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=267d0fee&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"
import style0 from "./Permission.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267d0fee')) {
      api.createRecord('267d0fee', component.options)
    } else {
      api.reload('267d0fee', component.options)
    }
    module.hot.accept("./Permission.vue?vue&type=template&id=267d0fee&", function () {
      api.rerender('267d0fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Permission.vue"
export default component.exports